import { createContext } from 'react';

export type ServerConfigContextShape = {
  headerEnv: string | null;
  awsRegionShort: string | null;
  appVersion: string | null;
  lemonadeStates: string[];
  akamaiBotHeader: string;
  proxyBasePath: string;
  abTestingEnabled: boolean;
  smsConsentEnabled: boolean;
  addressCheckEnabled: boolean;
  trupanionPreferredRetailerEnabled: boolean;
  guestQuoteEnabled: boolean;
  preGuestQuoteEmailCaptureEnabled: boolean;
  isCSR: boolean;
  quoteSimplificationEnabled: boolean;
  breedEducationModuleEnabled: boolean;
  chewyAnalyticsAleEnabled: boolean;
  visionM2Enabled: boolean;
  lemonadeEnhancedPreventativeBenefitsStates: string[];
};

export const ServerConfigContext = createContext<ServerConfigContextShape>({
  headerEnv: null,
  awsRegionShort: null,
  appVersion: null,
  lemonadeStates: [],
  akamaiBotHeader: '',
  proxyBasePath: '',
  smsConsentEnabled: false,
  addressCheckEnabled: false,
  abTestingEnabled: true,
  trupanionPreferredRetailerEnabled: false,
  guestQuoteEnabled: false,
  preGuestQuoteEmailCaptureEnabled: false,
  isCSR: false,
  quoteSimplificationEnabled: false,
  breedEducationModuleEnabled: false,
  chewyAnalyticsAleEnabled: false,
  visionM2Enabled: false,
  lemonadeEnhancedPreventativeBenefitsStates: [],
});
